"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M12.7.95c-4 0-7.35 2.18-9.77 6.28-.09-.13-.17-.27-.26-.4-.19-.31-.37-.63-.55-.95a17.9 17.9 0 0 1-.49-.98c-.08-.17-.16-.33-.23-.5-.04-.08-.08-.17-.11-.25a.973.973 0 0 0-.11-.23.546.546 0 0 0-.44-.22c-.12 0-.23.03-.32.11l-.03.03s-.09.11-.11.17c-.06.16-.03.33.02.48.04.13.09.27.14.4.13.41.26.83.4 1.24.07.23.15.47.22.7.32 1.01.65 2.05.92 2.87.09.28.15.59.28.85.04.08.12.18.21.22.07.04.16.05.26.02.02 0 .05-.02.07-.03l.33-.13.54-.21.7-.27c.27-.1.53-.21.8-.31l.84-.33.82-.32.74-.29.6-.24.21-.08c.07-.03.14-.06.21-.08.07-.03.14-.05.21-.08.08-.04.16-.09.22-.16.08-.11.12-.26.09-.39a.516.516 0 0 0-.6-.38l-1.53.36s-1.58.29-2.39.34c1.51-2.54 4.07-5.3 8.1-5.3 5.02 0 9.11 4.09 9.11 9.11s-4.09 9.11-9.11 9.11a9.07 9.07 0 0 1-4.63-1.27 9.47 9.47 0 0 1-1.87-1.47c-.16-.16-.3-.35-.45-.52-.19-.22-.36-.45-.53-.69-.08-.11-.15-.23-.22-.34-.18-.28-.35-.57-.49-.87l-.19-.4c-.2-.44-.66-.69-1.15-.55-.15.04-.29.12-.41.23-.14.13-.24.3-.28.49-.02.1-.03.2-.02.3.01.13.07.27.12.39.1.25.22.5.35.74.37.7.82 1.37 1.33 1.98.25.3.52.59.81.86.28.27.58.53.9.77a10.47 10.47 0 0 0 2.02 1.23c.36.17.73.32 1.11.45.38.13.77.24 1.16.33.4.09.8.16 1.21.2.41.05.83.07 1.24.07 6.09 0 11.05-4.96 11.05-11.05C23.75 5.9 18.79.95 12.7.95Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};